export default __webpack_public_path__ + "static/media/231122_Nomady_DigitalFormats_AppWelcome1.8bc3b47f.webp";